import axios from "axios";
import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const EditOrderModal = ({ order, setOrders }) => {
  const user = useSelector((state) => state.user);
  const [status, setStatus] = useState(order.status);

  const [showEdit, setShowEdit] = useState(false);
  const handleEdit = (orderId, userId, status) => {
    axios
      .put(
        `https://the-green-shop.herokuapp.com/api/orderDetail/editById/${orderId}/${userId}`,
        {
          orderStatus: status,
        }
      )
      .then(() => {
        axios
          .get(
            `https://the-green-shop.herokuapp.com/api/orderDetail/getAll/${user.id}`
          )
          .then((res) => {
            setOrders(res.data);
            setShowEdit(false);
          });
      });
  };
  return (
    <>
      <button className="btn btn-primary" onClick={() => setShowEdit(true)}>
        Edit
      </button>
      <Modal show={showEdit} onHide={() => setShowEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Update order status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="status">Status:</label>

          <Form.Select
            aria-label="Default select example"
            onChange={(e) => setStatus(e.target.value)}
            style={{ marginTop: "10px" }}
            defaultValue={status ? status : "pending"}
          >
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="shipped">Shipped</option>
            <option value="cancelled">Cancelled</option>
            <option value="refunded">Refunded</option>
          </Form.Select>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowEdit(false)}
          >
            Close
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              handleEdit(order.id, user.id, status);
            }}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditOrderModal;
